import React from "react";

export default function Disclaimer({
  overview,
  emulator,
  remote,
  noScreen,
  page,
  step,
}) {
  return (
    <div
      className={overview ? "alt-disclaimer" : "disclaimer"}
      style={{
        position: "absolute",
        bottom: overview ? "5px" : "0px",
        left: emulator ? "0px" : null,
        width:
          page !== "Emulator" && page !== "home" && page !== "magic_remote"
            ? "100%"
            : "90%",
        margin: emulator ? "0  0 0 calc(5% + 60px)" : overview ? "0 1%" : null,
        zIndex: step ? 9 : 1,
      }}
    >
      <p>
        {noScreen
          ? null
          : "Screen images are simulated for demonstration purposes and may vary."}{" "}
        {remote
          ? "Magic Remote design for US. AI and hot keys may be different depending on service availability."
          : null}
        {page === "Emulator" ||
        page === "lg-channels" ||
        page === "EPG" ||
        page === "quick-access-magic-remote" ? (
          <>
            <br />
            Channel numbers may vary by country.
          </>
        ) : null}
        {page === "iot" && step === 1 ? (
          <>
            <br /> Only LG home appliances that support ThinQ are available.
            Some functions may not be available if your location settings and
            language settings are different.
          </>
        ) : null}
        {page === "iot" && step === 2 ? (
          <>
            <br />
            <span style={{ color: "black", zIndex: "1000" }}>
              Only LG home appliances that support ThinQ are available. Some
              functions may not be available if your location settings and
              language settings are different.
            </span>
          </>
        ) : null}
      </p>
    </div>
  );
}
